module.exports = __webpack_public_path__ + "static/img/OM3.e90732fb.png";